// src/features/executive/sales/hooks/use-category-mix.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import SalesApi from 'api/executive/sales.api'
import type {
  CategoryMixResponse,
  GetCategoryMixParams,
  ExecutiveFilterState,
} from 'api/executive/executive.types'

export function useCategoryMix(scopedFilters?: Partial<ExecutiveFilterState>) {
  return useExecutiveQuery<GetCategoryMixParams, CategoryMixResponse>(
    'sales.category-mix',
    SalesApi.getCategoryMix,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        patientType: f.patientType ?? undefined,
        appointmentStatus: f.appointmentStatus ?? undefined,
        // txCategoryId intentionally omitted
      }
    },
    { scopedFilters }
  )
}
